import { gql } from "@apollo/client";

export const GET_ALL_PROVEEDOR_DISTRIBUIDOR = gql`
query GetAllProveedorDistribuidor(
    $skip: Int
    $take: Int
    $where: ProveedorDistribuidorFilterInput  
    $order : [ProveedorDistribuidorSortInput!] 
) {
    allProveedorDistribuidor(skip: $skip, take: $take, where: $where, order: $order )
    {
        items {
            idProveedorDistribuidor,
            codigoSAP,
            razonSocial,
            contacto,
            telefonoAdicional,
            observacion,
            activo,
            email,
            idDepositoNavigation {
                idDeposito,
                descripcion
            },
            proveedorMetodoCobroBulto{
                idProveedorMetodoCobroBulto,
                fechaDesde,
                fechaHasta
            },
            proveedorMetodoCobroKM{
                idProveedorMetodoCobroKM,
                fechaDesde,
                fechaHasta
            },
            proveedorMetodoCobroKilo{
                idProveedorMetodoCobroKilo,
                fechaDesde,
                fechaHasta
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;